// extracted by mini-css-extract-plugin
module.exports = {"heznizy":"heznizy","modalIssueNews":"modalIssueNews","hjh6mz4":"hjh6mz4","h1c7rl4f":"h1c7rl4f","h1ta5ka6":"h1ta5ka6","time":"time","category":"category","hqq3yv4":"hqq3yv4"};